import { React, Fragment } from "react";
import { Modal } from "antd";
import {
  Grid,
  Typography,
  Paper,
  useTheme,
} from "@material-ui/core";



export default function VendorsDetails({
  visible,
  handle2Cancel,
  warehouse,
  items,
}) {
  const theme = useTheme()



  return (
    <>
      <Modal
        title="Details du Warehouse"
        visible={visible}
        footer={[]}
        onCancel={handle2Cancel}
        width={700}
        zIndex= {theme.zIndex.drawer + 2}
      >
        <div>
          <Paper
            style={{
              padding: 5,
              paddingLeft: 20,
              paddingRight: 20,
              paddingBottom: 2,
              marginTop: 10,
            }}
          >
            <Grid container spacing={2}>
              <Grid container justify="space-between" item>
                <Grid item>
                  <Typography variant="overline"> Name </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="overline"> {warehouse.Name} </Typography>
                </Grid>
              </Grid> 
              <Grid container justify="space-between" item>
                <Grid item>
                  <Typography variant="overline"> Location </Typography>
                </Grid>
                <Grid item>
                  <Typography variant="overline"> {warehouse.Location} </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </div>   
       
      </Modal>
       
    </>
  );
}
